import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Card } from "react-bootstrap";
import logo from "../../../../src/assets/forbidden-lands/forbidden-lands-logo.webp";
import sectionDivider from "../../../../src/assets/forbidden-lands/session15/bitter-reach-page-banner-session-15.webp";
import "../../../index.css";
import { ContentContainer } from "../SessionSection";
import ModalComponent from "../modal/modal.component";
import ImageComponent from "../image/image.component";
import { useEffect } from "react";
import "./forbidden-lands-styles.scss";

import cover from "../../../../src/assets/forbidden-lands/session15/fbl-session-15-cover.webp";

import ataciara from "../../../../src/assets/forbidden-lands/session15/ataciara-familiar-spirit.webp";
import ghorza from "../../../../src/assets/forbidden-lands/session15/ghorza.webp";
import moose from "../../../../src/assets/forbidden-lands/session15/deniggi-moose.webp";
import legendMarmena from "../../../../src/assets/forbidden-lands/legend-tiles/legend-marmena-the-summer-elf.webp";
import legendAlabastor from "../../../../src/assets/forbidden-lands/legend-tiles/legend-alabastor.webp";
import legendTower from "../../../../src/assets/forbidden-lands/legend-tiles/legend-tower-of-the-farseers.webp";

const pageHeader = {
  color: "white",
  backgroundColor: "black",
  opacity: "1",
  marginTop: "20px",
  padding: "15px",
};
const cardStyle = {
  textAlign: "left",
  fontFamily: "Carter One",
  backgroundColor: "rgba(0, 0, 0, 1) ",
  color: "white",
  marginBottom: "15px",
};

const FBLSession15 = () => {
  const [showModal, setShowModal] = React.useState("");
  const [modalData, setModalData] = React.useState({});
  const handleClick = (img, body, isLegend, caption) => {
    setModalData({
      body: body,
      image: img,
      isLegend: isLegend,
      caption: caption,
    });
    handleOpenModal();
  };
  const handleOpenModal = () => {
    setShowModal("show");
  };
  const handleCloseModal = () => {
    setShowModal("", "");
  };

  const section1Data = [
    {
      title: "Legends & Stormegrave",
      anchor: "freedom-day",
      sectionTitleCssName: "sectionTitleFBL",
      text: (
        <div className="fblBodyText">
          <ImageComponent
            image={cover}
            caption="To the Tower, Part 2"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Ruenlocke attracts a named NPC, Brothers of the Bitter Reach hire a sherpa guide, and thievery and legends are the
            order of the day in the settlement of Stormegrave. And a cliffhanger ending as a shadowy spirit rises from an abandoned well in the tundra."
            isLegend={false}
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          Session started with{" "}
          <span style={{ color: "burlywood" }}>Stronghold activities</span>.
          <ImageComponent
            image={legendMarmena}
            caption="Legend: Marmena"
            cssClass="imageRight"
            handleClick={handleClick}
            modalBody="There came a time when the <b>elven arch druid Blaudewedd in Ravenland</b> was plagued by disturbing dreams of the Bitter Reach. 
            Fire and death filled her nights and from the abyssal depths, monstrosities bellowed for blood. 
            To seek an answer to these portents <b>she sent Marmena, her most trusted Redrunner, to the Bitter Reach</b>. What is it that awakens in the frozen wastes? Who has the answer to riddles of the ice?"
            isLegend={true}
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          <br />
          <br />
          Tordung brings in 4 silver farming at Ruenlocke. And while Ingmarg's
          man Chansomps sets up a trade tent, a{" "}
          <span style={{ color: "burlywood" }}>
            female orc named Tuuwa arrives{" "}
          </span>{" "}
          and offers to help build, pay her own way, and tell a legend if they
          let her stay and become part of the ground floor in Ruenlock. She
          tells the{" "}
          <span style={{ color: "lightblue" }}>
            Legend of Marmena, the Summer Elf
          </span>
          .
          <br />
          <br />
          <span style={{ color: "burlywood" }}>
            The Brothers of the Bitter Reach approach the settlement of
            Stormegrave
          </span>
          ; a collection of arctic yurts housing a couple dozen Ailanders with a
          tradeshop and tavern called the Brilliant Wolf acting as the two-story
          center of the settlement.
          <br />
          <br />
          <span style={{ color: "burlywood" }}>
            Blisster camps away from Stormegrave
          </span>{" "}
          to sleep and prepare for a night of robber as{" "}
          <span style={{ color: "burlywood" }}>
            Erollo the frailer and Lobo the wolfkin go to the town
          </span>
          .
          <br />
          <br />
          <ImageComponent
            image={ataciara}
            caption="Ataciara, Familiar Spirit"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Ataciara is the proprietor of the Brilliant Wolf tavern in Stormegrave."
            isLegend={false}
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          Inside the Brilliant Wolf, Lobo and Erollo meet an elder named{" "}
          <b>Ataciara "Familiar Spirit"</b> knitting something from hair near a
          fire. The acting leader of the town, a female Ailander named{" "}
          <b>Dennigi "Moose"</b> is present, and founding out the scene is a
          quiet <b>female orc named Horza</b> sitting near the 2nd fire.
          <br />
          <br />
          <ImageComponent
            image={legendTower}
            caption="Tower of the Farseers"
            cssClass="imageRight"
            handleClick={handleClick}
            modalBody="And so it was that the winter <b>elves built a tower that reached to the heavens</b>. There at the top, above the clouds, they could gaze at the stars and tease their secrets from them. These secrets they bound to soft parchment and committed to thick tomes.
<br/><br/>
But the <b>Dragon Mul</b> saw this and was wroth. He slew the stargazers and settled down in the Tower of the Farseers to guard it. He inscribed the signs of the stars in the floor of the uppermost chamber and there he laid down to rest. Never again would the course of the stars be disturbed"
            isLegend={true}
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          After spending 6 silver on drinks and boldly announcing they are
          following the trail of the coment toward the towor, Ataciara tells the
          party the{" "}
          <span style={{ color: "lightblue" }}>
            Legend of the Tower of the Farseers
          </span>
          .
          <br />
          <br />
          Lobo and Erollo buy supplies, including fresh arrows for Erollo, and
          when asking about precious treasures, Moose smiles and guides the part
          to an office room. Bundled in furs is a dead humanoid. It looks like a
          feral human, but Ghorza reveals the horrific third, clawed arm
          protruding from the creatures chest and a fourth vestigal arm from the
          side.
          <ImageComponent
            image={moose}
            caption="Dennigi 'Moose'"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Moose is the acting chief of the settlement of Stormegrave."
            isLegend={false}
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          <ImageComponent
            image={legendAlabastor}
            caption="Alabastor"
            cssClass="imageRight"
            handleClick={handleClick}
            modalBody="The <b>commander of the Misgrown</b> gathers his forces around his banner, which speaks to them with the doomed voices of the dead. 
            Arrow and spear turn away in disgust from him and thus the general fears no battle.
<br/><br/>
If you get caught by Alabastor, all you can do is to pray to your gods for a swift end. <b>He is without mercy</b> and 
thirstily drinks the blood of his vanquished foes from their own skulls."
            isLegend={true}
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          <br />
          <br />
          It is a horrific amalgam of human flesh made possible by demon magic
          using Mog as Moose tells it. Sorcerers in Ravenland have perfected
          melding body parts together using Mog.{" "}
          <span style={{ color: "burlywood" }}>
            These experiments are called the Misgrown
          </span>
          . The party is horrified. Moose tells of the legendary leader of the
          Misgrown who is said to be in the Bitter Reach, bent of domination.
          This is the{" "}
          <span style={{ color: "lightblue" }}>Legend of Alabastor</span>.
          <br />
          <br />
          Moose leads the party to a metal grate over a 5-foot wide hole in the
          tundra covered in snow and ice. They open the grate and Moose's most
          precious treasure is revealed as a huge female spider crawls up from
          the darkness toward the light. Moose speaks in Ailander in loving
          tones and announces this is{" "}
          <span style={{ color: "burlywood" }}>
            Igneqiex, the mother of all spiders
          </span>
          . The party is horrified and backs away from the grate. Moose tells
          them that Igneqiex loves to eat Misgrown. And so, as the Misgrown
          appear in the Bitter Reach, they are always welcome to bring the
          demonspawn to Stormegrave to be fet to the giant arachnid. And with
          that, they topple the corpse of the Misgrown into the hole.
          <br />
          <br />
          That night,{" "}
          <span style={{ color: "burlywood" }}>
            Blisster sneaks into the Brilliant Wolf and steals a Golden Cradle
          </span>
          . His twisted mind is set on finding a baby for the cradle. Thanks to
          lots of willpower points and NOCTURAL talent, Blisster finds a
          WEATHERED BABY (burning his Pride to do so) and gets back to camp
          without being caught.
          <br />
          <br />
          <a href="#pageTop">Back to Top</a>
        </div>
      ),
    },
  ];
  const section2Data = [
    {
      title: "Finding the Path",
      anchor: "freedom-day",
      sectionTitleCssName: "sectionTitleFBL",
      text: (
        <div className="fblBodyText">
          <ImageComponent
            image={ghorza}
            caption="Ghorza"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Ghorza is a femal orc met in Stormegrave. She is quiet and reserved. She killed a misgrown which was fed to the giant spider Igneqiex."
            isLegend={false}
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          <span style={{ color: "burlywood" }}>
            The party heads back to Northfall to sell the golden cradel and hire
            a sherpa guide
          </span>
          . At 2 silver a day it seems expensive. But, the party pays fives days
          up front in the first of a shiny gold piece. And within a day of
          travel it is clear the sherpa is a fantastic investment. Far fewer
          mishaps and better travel in general.
          <br />
          <br />
          Now the towered peaks of the Southern Range seem to loom just ahead.
          But still, with another day on the tundra before reaching the
          mountains, the party spies{" "}
          <span style={{ color: "burlywood" }}>a strange, solitary well</span>.
          A stone well with a wooden roof and missing bucket stands alone on the
          tundra, as if it may have been part of a settlement that disappeared.
          The well smells of damp earth. Peering inside, the well must be over a
          volanic area as the ground is not frozen and is the source of the
          smell. There is a{" "}
          <span style={{ color: "burlywood" }}>
            long, thin glinting object leaning against the wall of the well no
            more than 15 feet down
          </span>
          , and something else slupmed against the earthen sides. It is hard to
          see in the pale winter light.
          <br />
          <br />
          As each of the party looks into the well they hear a sibilantn voice
          in their heards quietly chattering and howling. Lobo recognizes it as
          lupine speak. The voice is lamenting a lost battle and the potential
          for enormous power. Then, with a wild shriek, a towering{" "}
          <span style={{ color: "burlywood" }}>
            blast of shadow erupts from the well with a vague, shifting face and
            black tendrils of icy death
          </span>
          .
          <br />
          <br />
          And that's the end of the session. The party is left with a
          cliffhanger as they are about to be attacked by a shadowy spirit
          rising from the well.
          <br />
          <br />
          <small>Attendees: Blisster, Lobo, and Erollo.</small>
          <br />
          <small>Ending Datetime: 12pm, Springrise 16, 1165</small>
          <h5>XP</h5>
          <ul>
            <li>Session 1.0</li>
            <li>
              Legend: 3.0 (Legend of Marmena, Summer Elf told by Tuuwa the
              female orc at Ruenlocke; Legend of the Tower of Farseers by
              Ataciara in settlement of Stormegrave; Legend of Alabastor told by
              Moose in Stormegrave){" "}
            </li>
            <li>Lore: 0.0</li>
            <li>Hex: 1.0</li>
            <li>
              Pride: 1.0 (Blisster used Pride, failed; no pride next session.
            </li>
            <li>Treasure: 0.0</li>
            <li>Monster: 0.0</li>
            <li>Dark Secret: 0.0</li>
            <li>
              <strong>TOTAL: 5.0 (6 for Lobo)</strong>
            </li>
          </ul>
          Next session we pick right up with battle at the mysterious well.
          <br />
          <br />
          <a href="#pageTop">Back to Top</a>
        </div>
      ),
    },
  ];

  useEffect(() => {
    document.body.style.backgroundImage = `url(${require("../../../../src/assets/forbidden-lands/fbl-page-background-blizzard.webp")})`;
    document.body.style.backgroundColor = "#000000";
    document.body.style.backgroundWidth = "100vw";
    document.body.backgroundHeight = "100vh";
    document.body.style.backgroundSize = "cover";
  }, []);

  return (
    <Container>
      <Row>
        <Col>
          <div
            style={{
              backgroundColor: "transparent",
              fontFamily: "IM Fell Great Primer",
            }}
          >
            <div style={pageHeader}>
              <main role="main" className="inner cover text-center">
                <a href="#freedom-day" name="pageTop">
                  <img
                    src={logo}
                    style={{ maxWidth: "200px" }}
                    alt="Forbidden Lands Campaign"
                  />
                </a>
              </main>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card style={cardStyle}>
            <img src={sectionDivider} alt="section divider" />
            <Card.Body>
              <Card.Title
                id="cardTitle-forbidden-lands"
                className="cardTitle-forbidden-lands  "
              >
                Ruenlocke attracts named NPC, Brothers of the Bitter Reach hire
                sherpa guide, thievery and legends are order of the day in
                Stormegrave. And a cliffhanger ending as a shadowy spirit rises
                from an abandoned tundra well.
                <br />
                <br />
                <small>
                  ⇐ Session 14:{" "}
                  <a href="./forbidden-lands-session-14">
                    To the Tower, Part 1
                  </a>
                  ☠ Session 16-17:{" "}
                  <a href="./forbidden-lands-session-16_17">Assare's Harpoon</a>{" "}
                  ⇒{" "}
                  {/* ☠
                  Session 16:{" "}
                  <a href="./forbidden-lands-session-16">
                    Tower of the Farseers
                  </a>{" "}
                  ⇒{" "} */}
                </small>
              </Card.Title>
              <div>
                <ContentContainer data={section1Data} />
              </div>
              <div>
                <ContentContainer data={section2Data} />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default FBLSession15;
